import ConfiguracaoSistemaService from "@/services/ConfiguracaoSistemaService.js";

/**
 * Regras de CST do IBS/CBS por municipio (NT 009), persistidas como JSON
 * dentro do recurso generico `configuracao_sistema` (mesmo backend usado
 * pela tela de Variaveis de Sistema), sob uma chave fixa.
 *
 * Formato do JSON gravado na coluna `valor`:
 * {
 *   "padrao_cst": "01",
 *   "excecoes": {
 *     "1302603": { "nome": "Manaus", "cst": "08" }
 *   }
 * }
 */
const CHAVE = "FISCAL_REGRA_IBS_CBS";
const DESCRICAO = "CST padrao e excecoes por municipio (IBS/CBS) - NT 009 CNPJ Alfanumerico";

const regraPadrao = () => ({
  padrao_cst: "",
  excecoes: {}
});

const FiscalRegraIbsCbsService = {
  /**
   * Busca a regra atual. Se a chave ainda nao existir, devolve a regra padrao
   * com id nulo (o `salvar` decide entre cadastrar ou atualizar a partir disso).
   */
  async buscar () {
    const configuracoes = await ConfiguracaoSistemaService.listar();
    const registro = configuracoes.find(item => item.chave === CHAVE);
    if (!registro) {
      return { id: null, regra: regraPadrao() };
    }
    let regra;
    try {
      regra = JSON.parse(registro.valor);
    } catch (err) {
      regra = regraPadrao();
    }
    return {
      id: registro.id,
      regra: {
        padrao_cst: regra.padrao_cst || "",
        excecoes: regra.excecoes || {}
      }
    };
  },

  /**
   * Persiste a regra completa (padroes + excecoes) em uma unica chave.
   */
  async salvar (id, regra) {
    const payload = {
      chave: CHAVE,
      valor: JSON.stringify(regra),
      descricao: DESCRICAO
    };
    if (id) {
      return await ConfiguracaoSistemaService.atualizar(id, payload);
    }
    return await ConfiguracaoSistemaService.cadastrar(payload);
  }
};

export default FiscalRegraIbsCbsService;
